import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const updateLeadDefaultChannel = createAsyncThunk("LeadRoutingOverView/updateLeadDefaultChannel", async (data, thunkAPI) => {
  try {
    const resp = await axios.put(`${process.env.REACT_APP_BASE_URL}api/lead-routing/default-channel`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
